import { Component, EventEmitter, Output } from '@angular/core';
import { ApiserviceService } from '../../../../../../src/app/apiservice.service';

@Component({
  selector: 'app-master-list',
  templateUrl: './master-list.component.html',
  styleUrls: ['./master-list.component.scss']
})
export class MasterListComponent {
  @Output() masterSelected = new EventEmitter<any>();
  @Output() updateMaster = new EventEmitter<any>();
  @Output() masterDataList = new EventEmitter<any>();
  masters: any[] = []
// masters: any[] = [

// ]
  selectedMasterId: number | null = null;
  selectedMaster: any;
  isLoading: boolean = false;
  currentLangId: number;
  constructor(
    private api: ApiserviceService
  ){
  this.currentLangId = this.api.language;
  }

  ngOnInit(): void {
    // Select first master by default if available
     this.fetchMasterData(true)
  }

  selectMaster(masterId: number, refetch: boolean = true): void {
    this.selectedMasterId = masterId;
    const selectedMaster = this.masters.find(m => m.id === masterId);
    this.masterSelected.emit(selectedMaster);
    // Call your function here
    this.fetchMasterData();
  }

fetchMasterData(selectFirst: boolean = false) {
  const url = "masters";
  this.isLoading = true;
this.api.getGmsData(url).subscribe({
  next: (res:any) => {
    this.masters = res.data;
    this.isLoading = false;
    this.masterDataList.emit(this.masters);
     if (selectFirst && this.masters.length > 0) {
        this.selectMaster(this.masters[0].id, false); // false = don't fetch again
      }
  },
  error: (err) => {
    this.isLoading = false
    console.error('Error creating master', err);
  }
})
}
editMaster(event, master){
  event.stopPropagation();
   this.updateMaster.emit(master);
}
}
